export class HttpError extends Error {
  constructor(
    public status: number,
    public message: string,
    public body?: unknown
  ) {
    super(message)
  }
}
